module.exports = __webpack_public_path__ + "img/corneal-staining-3.75afe4d7.jpg";